/** @format */

import React, { FC, useEffect, useState, useContext } from 'react'
import { _$, Drawer, Button, Tooltip, Tag } from '@king-design/react'
import styled from 'styled-components'
import TablePage from 'src/components/TablePage'
import useFormTable from 'src/hooks/useFormTable'
import { formatDate } from 'src/utils'
import API from 'src/api/ApiEventCenter'
import { CountContext } from 'src/pages/EventCenter'
import { DetailDrawerProps } from './constants'
import Cookies from 'js-cookie'

const lang = Cookies.get('ksc_lang')
const DetailDrawer: FC<DetailDrawerProps> = ({ className, visible, setVisible, data }) => {
  const { date, regionList, query } = useContext(CountContext)
  const [searchKeywords, setSearchKeywords] = useState<string>(query)
  useEffect(() => {
    if (visible) {
      setSearchKeywords(query)
      run({
        searchKeywords: query
      })
    } else {
      resetPage()
    }
  }, [visible, query])
  // useFormTable
  const { run, result, pageState, loading, total, resetPage } = useFormTable(
    API.getDescribeSystemEventAttribute,
    {
      params: {
        NamespaceId: data?.namespaceId,
        Name: data?.name,
        StartTime: date.start,
        EndTime: date.end,
        searchKeywords
      },
      manual: true
    },
    res => ({
      tableData: res?.systemEvents?.systemEvent || [],
      totalCount: parseInt(data?.num || 0)
    })
  )

  const tableScheme = React.useMemo(() => {
    const scheme = {
      instanceName: {
        title: _$('关联实例'),
        template({ instanceName, instanceId }) {
          return (
            <div>
              <Tooltip content={instanceName}>
                <span className="text-overflow">{instanceName}</span>
              </Tooltip>
              <p style={{ color: '#999' }}>{instanceId}</p>
            </div>
          )
        }
      },
      regionId: {
        title: _$('所属区域'),
        width: 100,
        template: item => {
          if (lang === 'en') {
            return item.regionId
          } else {
            const findRegion = regionList?.find(({ regionKey }) => {
              return regionKey === item.regionId
            })
            return findRegion?.regionName || ''
          }
        }
      },
      time: {
        title: _$('时间'),
        width: 100,
        template: item => formatDate(item.time)
      },
      tags: {
        title: 'tags',
        width: 150,
        template: (item: any) => {
          const filter = item.tags.filter(
            tag => tag.indexOf('groupid') !== 0 && tag.indexOf('host') !== 0
          )
          return filter.map(item => <p style={{ margin: '4px 0' }}>{item}</p>)
        }
      },
      content: {
        title: _$('内容'),
        template: item => (
          <p
            style={{ whiteSpace: 'pre-wrap' }}
            dangerouslySetInnerHTML={{ __html: item.content }}
          ></p>
        )
      }
    }
    if (result?.[0]?.tags?.length < 3) {
      delete scheme.tags
    }
    return scheme
  }, [result])

  return (
    <Drawer
      title={_$('事件详情')}
      value={visible}
      width={1000}
      mode="destroy"
      onClose={() => {
        setVisible(false)
      }}
      slotFooter={
        <>
          <Button
            type="primary"
            onClick={() => {
              setVisible(false)
            }}
          >
            {_$('关闭')}
          </Button>
        </>
      }
    >
      <div className={className}>
        {searchKeywords ? (
          <div className="search">
            <p>
              当前搜索内容：
              <Tag
                closable
                size="large"
                onClose={() => {
                  setSearchKeywords('')
                  run({ searchKeywords: '' })
                }}
              >
                {searchKeywords}
              </Tag>
            </p>
          </div>
        ) : null}
        <div className="header">
          <p>
            {_$('产品类型')}：{data?.productName || ''}
          </p>
          <p>
            {_$('事件类型')}：{data?.eventTypeName || ''}
          </p>
          <p>
            {_$('事件等级')}：{data?.level || ''}
          </p>
          <p>
            {_$('事件名称')}：{data?.eventName || ''}
          </p>
        </div>
        <div className="table">
          <TablePage
            tableProps={{
              data: result,
              scheme: tableScheme,
              resizable: true,
              checkType: 'none',
              rowKey: value => `${value.instanceId}-${value.time}`
            }}
            run={run}
            pageProps={{ total, ...pageState, size: 'small' }}
            loading={loading}
          />
        </div>
      </div>
    </Drawer>
  )
}

export default styled(DetailDrawer)`
  .header,
  .search {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    p {
      width: 50%;
      font-size: 14px;
    }
  }
`
